export default "__VITE_ASSET__DSWM_tts__"